import React from "react";

interface Props {
  className?: string;
}

const CommentBubbleSvg: React.FC<Props> = (props) => {
  return (
    <svg
      viewBox="0 0 15 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <path
        d="M2.71859 10.75C2.10804 10.75 1.52249 10.5075 1.09077 10.0757C0.659044 9.64401 0.416504 9.05847 0.416504 8.44792V2.42708C0.416504 1.81653 0.659044 1.23099 1.09077 0.799264C1.52249 0.36754 2.10804 0.125 2.71859 0.125H12.2811C12.5834 0.125 12.8828 0.184545 13.1621 0.300236C13.4414 0.415926 13.6951 0.585496 13.9089 0.799264C14.1227 1.01303 14.2922 1.26681 14.4079 1.54611C14.5236 1.82542 14.5832 2.12477 14.5832 2.42708V8.44792C14.5832 8.75023 14.5236 9.04958 14.4079 9.32889C14.2922 9.60819 14.1227 9.86197 13.9089 10.0757C13.6951 10.2895 13.4414 10.4591 13.1621 10.5748C12.8828 10.6905 12.5834 10.75 12.2811 10.75H8.21667L4.6665 13.4062C4.53496 13.5047 4.37861 13.5646 4.21495 13.5793C4.05129 13.5939 3.88678 13.5628 3.73983 13.4892C3.59288 13.4157 3.46929 13.3028 3.38287 13.163C3.29646 13.0233 3.25064 12.8622 3.25055 12.6979V10.75H2.7193H2.71859ZM7.86392 9.6875H12.2811C12.6098 9.6875 12.9251 9.5569 13.1576 9.32443C13.3901 9.09197 13.5207 8.77667 13.5207 8.44792V2.42708C13.5207 2.09833 13.3901 1.78303 13.1576 1.55057C12.9251 1.3181 12.6098 1.1875 12.2811 1.1875H2.71859C2.38983 1.1875 2.07454 1.3181 1.84207 1.55057C1.6096 1.78303 1.479 2.09833 1.479 2.42708V8.44792C1.479 9.13217 2.03434 9.6875 2.71859 9.6875H4.31163V12.3438L7.86392 9.6875Z"
      />
    </svg>
  );
};

CommentBubbleSvg.defaultProps = {
  className: "w-8 h-8 stroke-current text-black",
};

export default CommentBubbleSvg;
